module.exports = __webpack_public_path__ + "fonts/Montserrat-Black.21d17f91.woff";